import Close from '@mui/icons-material/Close'
import List from '@mui/icons-material/List'
import ExpandMore from '@mui/icons-material/ExpandMore'
import AccessTime from '@mui/icons-material/AccessTime'
import Person from '@mui/icons-material/Person'
import Payment from '@mui/icons-material/Payment'
import Phone from '@mui/icons-material/Phone'
import Email from '@mui/icons-material/Email'
import CalendarToday from '@mui/icons-material/CalendarToday'
import LocalHospital from '@mui/icons-material/LocalHospital'
import VideoCall from '@mui/icons-material/VideoCall'
import PersonPinCircle from '@mui/icons-material/PersonPinCircle'
import Receipt from '@mui/icons-material/Receipt'
import CheckCircle from '@mui/icons-material/CheckCircle'
import Cancel from '@mui/icons-material/Cancel'
import Block from '@mui/icons-material/Block'
import Info from '@mui/icons-material/Info'
import Business from '@mui/icons-material/Business'
import LocationOn from '@mui/icons-material/LocationOn'
import Groups from '@mui/icons-material/Groups'
import Chair from '@mui/icons-material/Chair'
import VideoCameraFront from '@mui/icons-material/VideoCameraFront'
import DoNotDisturb from '@mui/icons-material/DoNotDisturb'
import { useBodyScrollLock } from 'src/hooks/useBodyScrollLock'
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from '@mui/material'
import dayjs from 'dayjs'
import { useState, useMemo, useEffect } from 'react'
import { useMultipleDialogs } from '../slotItem/hooks/useDialogState'
import { Dialog } from '@mui/material'
import JoiningDetails from '../slotItem/component/JoiningDetails'
import BookedEventLogsDrawer from './BookedEventLogsDrawer'
import EmrImagesUploadDialog from '../emrImagesUpload/EmrImagesUploadDialog'
import RescheduleSlotDialog from '../slotItem/components/RescheduleSlotDialog'
import SendPrescriptionImagesDialog from '../sendPrescriptionImages/SendPrescriptionImagesDialog'
import PaymentLinksViewer from '../slotItem/component/PaymentLinksViewer'
import { EVENT_TYPE_THERAPY_SESSION, EVENT_TYPE_SCREENING, EVENT_TYPE_CONSULTATION } from 'src/consumer/constants'
import { 
  SESSION_PLATFORM_OFFLINE, 
  SESSION_PLATFORM_ONLINE,
  BOOKING_STATUSES,
  BOOKING_PAYMENT_STATUSES,
  STATUS_SESSION_CANCELLED,
  OFFLINE_PAYMENT_METHODS_LIST,
  GENDER_LIST_ONBOARDING,
  displayNamesOfEventTypes,
  VISIT_EVENT_TYPES,
  BOOKING_SESSION_STATUS,
} from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { getOrdinalSuffixForSuperScript } from 'src/consumer/helpers/utilFunctions'
import { getBookedSlotStripColor } from '../DayViewCalendarComponent'
import SlotPopupSummary from '../slotItem/SlotPopupSummary'
import BookedSlotActionsAccordion from './BookedSlotActionsAccordion'
import styled from 'styled-components'
import { FilterTag } from '../ClinicManageBookingsPageStyles'
import { putSPDataWithParams } from 'src/supportPortal/services/services'
import { isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { toast } from 'react-toastify'

const DrawerContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(250, 250, 255, 0.98) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
`

const DrawerHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(67, 56, 202, 0.1);
  background: linear-gradient(135deg, rgba(67, 56, 202, 0.04) 0%, rgba(99, 102, 241, 0.04) 100%);
  
  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`

const DrawerTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
  color: rgba(67, 56, 202, 0.9);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const DrawerContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  
  @media (max-width: 768px) {
    padding: 12px;
  }
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(67, 56, 202, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(67, 56, 202, 0.2);
    border-radius: 4px;
    
    &:hover {
      background: rgba(67, 56, 202, 0.3);
    }
  }
`

const SlotAccordion = styled(Accordion).attrs(props => ({
  'data-background': props.$background,
  'data-bordercolor': props.$borderColor,
}))`
  margin-bottom: 12px !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05) !important;
  border: 3px solid ${props => props.$borderColor || '#6366F1'} !important;
  background: ${props => props.$background || '#E8E9EA'} !important;
  overflow: hidden;
  transition: all 0.3s ease !important;
  
  &:before {
    display: none;
  }
  
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08) !important;
    border-width: 4px !important;
    transform: translateY(-2px);
  }
  
  &.Mui-expanded {
    margin-bottom: 12px !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15), 0 3px 10px rgba(0, 0, 0, 0.1) !important;
    border-width: 3px !important;
  }
`

const AccordionHeader = styled(AccordionSummary)`
  padding: 16px 20px !important;
  min-height: auto !important;
  background: transparent !important;
  
  &.Mui-expanded {
    min-height: auto !important;
    border-bottom: 2px solid ${props => props.$borderColor || '#6366F1'} !important;
    opacity: 0.9;
  }
  
  .MuiAccordionSummary-content {
    margin: 0 !important;
    align-items: center;
  }
  
  @media (max-width: 768px) {
    padding: 12px 16px !important;
  }
`

const AccordionContent = styled(AccordionDetails)`
  padding: 20px !important;
  background: rgba(255, 255, 255, 0.95);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  
  @media (max-width: 768px) {
    padding: 16px !important;
  }
`

const MainInfoRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`

const LeftSection = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
  min-width: 0;
`

const RightSection = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
`

const PatientName = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  line-height: 1.3;
  word-break: break-word;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`

const TimeDisplay = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`

const StatusChip = styled(Chip)`
  height: 28px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

const InfoRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(67, 56, 202, 0.08);
  
  &:last-child {
    border-bottom: none;
  }
`

const InfoLabel = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  color: rgba(67, 56, 202, 0.7);
  min-width: 120px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`

const InfoValue = styled(Typography)`
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  flex: 1;
  word-break: break-word;
`


const EmptyState = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: rgba(67, 56, 202, 0.5);
`

const EmptyStateText = styled(Typography)`
  font-size: 14px;
  color: rgba(67, 56, 202, 0.6);
  margin-top: 12px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
`

const SecondaryInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 4px;
`

const SecondaryChip = styled(Chip)`
  height: 22px;
  font-size: 10px;
  font-weight: 500;
`

export default function BookedSlotsDrawer({
  selectedClinic,
  clinicAssociations = [],
  open,
  onClose,
  bookedSlotsInDay,
  selectedDate,
  forMentor = false,
  goToEvent,
  markBookedSessionAsCompletedFunction,
  getAndSetBookedSlotsOfSelectedDate,
  setCancelDialogData,
  setEditPatientDialogOpen,
  setClickedBookedSlotData,
  setEditBookingDialogOpen,
  setAddVitalsDialogOpen,
  setDataForTherapyBookingDialog,
  setTherapyBookingDialogOpen,
  handleNewTherapyRequest,
  pendingActionsOfPerson = [],
  platformOptions = [],
  bookedSlotActionText,
  hideStartButton = false,
  hideMarkedCompletedButton = false,
  canPersonPrintPrescription = false,
  openReceiptDialog,
  setEventDataForReceiptPrinting,
  openUploadPrescriptionImagesDialog,
  openPaymentLinksDialog,
  openEmrImagesDialog,
  openRescheduleDialog,
  hideRescheduleDialog = false,
  openBookedEventLogs,
  displayNamesOfEventTypes = {},
  openReportViewDrawer,
  initialFilterType = 'all',
}) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  
  // Lock body scroll when drawer is open
  useBodyScrollLock(open, 1300)
  
  const [selectedSlot, setSelectedSlot] = useState(null)
  const [slotPopupAnchor, setSlotPopupAnchor] = useState(null)
  const [expandedSlots, setExpandedSlots] = useState(new Set())
  const [currentSlotForDialogs, setCurrentSlotForDialogs] = useState(null)
  const [drawerFilterType, setDrawerFilterType] = useState(initialFilterType)

  // Create dialog handlers - these will work with currentSlotForDialogs
  const dialogs = useMultipleDialogs([
    'joiningDetails',
    'bookedEventLogs',
    'uploadPrescriptionImages',
    'emrImages',
    'reschedule',
    'paymentLinks',
  ])

  // Helper to create handlers that set the current slot and open dialog
  const createSlotHandler = (slot, dialogName) => {
    return () => {
      setCurrentSlotForDialogs(slot)
      dialogs[dialogName].open()
    }
  }

  // Helper to close dialog and reset current slot
  const createCloseHandler = (dialogName) => {
    return () => {
      dialogs[dialogName].close()
      // Reset current slot after a short delay to allow dialog close animation
      setTimeout(() => {
        setCurrentSlotForDialogs(null)
      }, 300)
    }
  }

  // Handler for toggle recording
  const createToggleRecordingHandler = (slot) => {
    return async () => {
      const loadingToast = toast.loading('Updating Recording Status...')
      const apiUrl = !slot?.recordingEnabled
        ? '/api/secure/cc/support/events/mark-event-as-recordable'
        : '/api/secure/cc/support/events/mark-event-as-not-recordable'

      const resp = await putSPDataWithParams(apiUrl, null, {
        'booked-event-id': slot?.id,
      })

      if (resp.status === 200 && isCommonResponseSuccessfulV2(resp)) {
        getAndSetBookedSlotsOfSelectedDate()
        toast.update(loadingToast, {
          render: 'Recording Status Updated',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      } else {
        toast.update(loadingToast, {
          render: 'Failed to update recording status',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }
    }
  }

  const handleSlotExpand = (slotId, event) => {
    event.stopPropagation()
    setExpandedSlots(prev => {
      const newSet = new Set(prev)
      if (newSet.has(slotId)) {
        newSet.delete(slotId)
      } else {
        newSet.add(slotId)
      }
      return newSet
    })
  }

  // Helper function to get clinic data from associations
  const getClinicDataFromAssociations = (clinicId, clinicBrandId) => {
    const clinicAssociation = clinicAssociations.find(
      (clinic) => clinic?.id === clinicId || clinic?.clinicId === clinicId
    )
    if (clinicAssociation) {
      return {
        clinicBrandName: clinicAssociation?.clinicBrandName,
        clinicLocationName: clinicAssociation?.title, // title is the clinic location name
        clinicBrandId: clinicAssociation?.clinicBrandId || clinicBrandId,
        clinicId: clinicAssociation?.id || clinicAssociation?.clinicId || clinicId,
      }
    }
    return null
  }

  const formatTime = (timeString) => {
    if (!timeString) return ''
    return dayjs(timeString).format('h:mm A')
  }

  const formatDateTime = (timeString) => {
    if (!timeString) return ''
    return dayjs(timeString).format('MMM DD, YYYY h:mm A')
  }

  const getSlotType = (slot) => {
    if (slot?.meetingSrc === SESSION_PLATFORM_ONLINE) return 'video'
    if (slot?.meetingSrc === SESSION_PLATFORM_OFFLINE) return 'inPerson'
    return 'other'
  }

  const getStatusLabel = (slot) => {
    if (slot?.status === STATUS_SESSION_CANCELLED || slot?.status === 'CANCELLED') return 'Cancelled'
    if (slot?.status === BOOKING_STATUSES.BOOKING_INITIATED && slot?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING) return 'Payment Pending'
    if (slot?.markedCompleted) return 'Completed'
    if (slot?.sessionStatus === 'in-progress') return 'In Progress'
    if (slot?.visitEventType === VISIT_EVENT_TYPES.emergency) return 'Emergency'
    return 'Scheduled'
  }

  // Update drawer filter when initialFilterType changes
  useEffect(() => {
    setDrawerFilterType(initialFilterType)
  }, [open, initialFilterType])

  // Calculate filter counts
  const filterCounts = useMemo(() => {
    if (!bookedSlotsInDay || bookedSlotsInDay.length === 0) {
      return { inPerson: 0, video: 0, cancelled: 0 }
    }
    return {
      inPerson: bookedSlotsInDay.filter(slot => slot?.meetingSrc === SESSION_PLATFORM_OFFLINE).length,
      video: bookedSlotsInDay.filter(slot => slot?.meetingSrc === SESSION_PLATFORM_ONLINE).length,
      cancelled: bookedSlotsInDay.filter(slot => 
        slot?.status === STATUS_SESSION_CANCELLED || slot?.status === 'CANCELLED'
      ).length,
    }
  }, [bookedSlotsInDay])

  // Memoize sorted and filtered slots
  const sortedSlots = useMemo(() => {
    if (!bookedSlotsInDay || bookedSlotsInDay.length === 0) {
      return []
    }
    
    let filtered = [...bookedSlotsInDay]
    
    // Apply filter
    if (drawerFilterType === 'inPerson') {
      filtered = filtered.filter(slot => slot?.meetingSrc === SESSION_PLATFORM_OFFLINE)
    } else if (drawerFilterType === 'video') {
      filtered = filtered.filter(slot => slot?.meetingSrc === SESSION_PLATFORM_ONLINE)
    } else if (drawerFilterType === 'cancelled') {
      filtered = filtered.filter(slot => 
        slot?.status === STATUS_SESSION_CANCELLED || slot?.status === 'CANCELLED'
      )
    }
    
    // Sort by time
    return filtered.sort((a, b) => {
      const timeA = dayjs(a?.startTimeForDayCal || a?.slotStart || a?.startTime)
      const timeB = dayjs(b?.startTimeForDayCal || b?.slotStart || b?.startTime)
      return timeA.diff(timeB)
    })
  }, [bookedSlotsInDay, drawerFilterType])

  return (
    <>
      <Drawer
        anchor={isMobile ? 'bottom' : 'right'}
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: isMobile ? '100%' : 480,
            maxWidth: isMobile ? '100%' : '90vw',
            height: isMobile ? '90vh' : '100%',
            maxHeight: isMobile ? '90vh' : '100vh',
            borderTopLeftRadius: isMobile ? '20px' : 0,
            borderTopRightRadius: isMobile ? '20px' : 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          },
        }}
        ModalProps={{
          disableScrollLock: true, // We handle scroll lock with useBodyScrollLock hook
        }}
      >
        <DrawerContainer>
          {/* Drag Handle for Mobile Bottom Sheet */}
          {isMobile && (
            <Box
              sx={{
                width: '40px',
                height: '4px',
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '2px',
                margin: '8px auto',
                cursor: 'grab',
                '&:active': {
                  cursor: 'grabbing',
                },
              }}
            />
          )}
          <DrawerHeader>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <List sx={{ color: 'rgba(67, 56, 202, 0.7)', fontSize: 20 }} />
              <DrawerTitle>
                Booked Slots
                {selectedDate && (
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '13px',
                      fontWeight: 400,
                      color: 'rgba(67, 56, 202, 0.6)',
                      marginLeft: 1,
                    }}
                  >
                    ({dayjs(selectedDate, 'DD-MM-YYYY').format('MMM DD')})
                  </Typography>
                )}
              </DrawerTitle>
            </Box>
            <IconButton
              onClick={onClose}
              sx={{
                color: 'rgba(67, 56, 202, 0.7)',
                padding: isMobile ? '12px' : '8px',
                minWidth: isMobile ? '48px' : '40px',
                minHeight: isMobile ? '48px' : '40px',
                '&:hover': {
                  backgroundColor: 'rgba(67, 56, 202, 0.08)',
                  color: 'rgba(67, 56, 202, 1)',
                },
              }}
            >
              <Close />
            </IconButton>
          </DrawerHeader>

          <DrawerContent>
            {/* Filter Pills */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                mb: 2,
                flexWrap: 'wrap',
                pb: 2,
                borderBottom: '1px solid rgba(67, 56, 202, 0.1)',
              }}
            >
              <FilterTag 
                selected={drawerFilterType === 'all'}
                onClick={() => setDrawerFilterType('all')}
              >
                <Groups />
                <span className="chip-label">All Patients</span>
                <span style={{ fontSize: '11px', opacity: 0.7 }}>
                  ({filterCounts.inPerson + filterCounts.video})
                </span>
              </FilterTag>
              <FilterTag 
                selected={drawerFilterType === 'inPerson'}
                onClick={() => setDrawerFilterType('inPerson')}
              >
                <Chair />
                <span className="chip-label">In Person</span>
                <span style={{ fontSize: '11px', opacity: 0.7 }}>
                  ({filterCounts.inPerson})
                </span>
              </FilterTag>
              <FilterTag 
                selected={drawerFilterType === 'video'}
                onClick={() => setDrawerFilterType('video')}
              >
                <VideoCameraFront />
                <span className="chip-label">Video Call</span>
                <span style={{ fontSize: '11px', opacity: 0.7 }}>
                  ({filterCounts.video})
                </span>
              </FilterTag>
              {filterCounts.cancelled > 0 && (
                <FilterTag 
                  selected={drawerFilterType === 'cancelled'}
                  onClick={() => setDrawerFilterType('cancelled')}
                >
                  <DoNotDisturb />
                  <span className="chip-label">Cancelled</span>
                  <span style={{ fontSize: '11px', opacity: 0.7 }}>
                    ({filterCounts.cancelled})
                  </span>
                </FilterTag>
              )}
              {drawerFilterType !== 'all' && (
                <FilterTag 
                  selected={false}
                  onClick={() => setDrawerFilterType('all')}
                  style={{ 
                    border: '1px dashed rgba(67, 56, 202, 0.3)',
                    background: 'transparent',
                  }}
                >
                  <span className="chip-label">Clear Filter</span>
                </FilterTag>
              )}
            </Box>

            {sortedSlots.length === 0 ? (
              <EmptyState>
                <List sx={{ fontSize: 48, color: 'rgba(67, 56, 202, 0.3)' }} />
                <EmptyStateText>
                  {drawerFilterType === 'all' 
                    ? 'No booked slots for this day'
                    : drawerFilterType === 'inPerson'
                    ? 'No in-person bookings for this day'
                    : drawerFilterType === 'video'
                    ? 'No video call bookings for this day'
                    : drawerFilterType === 'cancelled'
                    ? 'No cancelled bookings for this day'
                    : 'No booked slots match the selected filter'}
                </EmptyStateText>
              </EmptyState>
            ) : (
              sortedSlots.map((slot, index) => {
                const slotTime = slot?.startTimeForDayCal || slot?.slotStart || slot?.startTime
                const slotEndTime = slot?.endTimeForDayCal || slot?.endTime
                const slotType = getSlotType(slot)
                const isCompleted = slot?.markedCompleted
                const isCancelled = slot?.status === STATUS_SESSION_CANCELLED || slot?.status === 'CANCELLED'
                const isPaymentPending = slot?.status === BOOKING_STATUSES.BOOKING_INITIATED && 
                                         slot?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
                const isExpanded = expandedSlots.has(slot?.id || index)
                
                // Get colors from calendar's color scheme
                // Check if slot is from different clinic
                const isSlotFromDifferentClinic = selectedClinic?.id && slot?.clinicId && selectedClinic.id !== slot.clinicId
                const isSupportPortal = typeof window !== 'undefined' && window.location?.pathname?.includes('/support')
                const showAsNormalForMentorOrSupport = (forMentor || isSupportPortal) && isSlotFromDifferentClinic
                const showClinicIndicator = isSlotFromDifferentClinic && (forMentor || isSupportPortal)
                
                const slotColors = getBookedSlotStripColor(slot, isSlotFromDifferentClinic, showAsNormalForMentorOrSupport)
                const isBlocked = isSlotFromDifferentClinic && !showAsNormalForMentorOrSupport
                
                // Calculate therapyBookingDataForThisEvent for this specific slot
                const pendingActionsForThisBookedEvent = pendingActionsOfPerson?.filter(
                  (pa) => pa?.bookedEventId === slot?.id
                ) || []
                const therapyBookingDataForThisEvent = pendingActionsForThisBookedEvent?.find(
                  (pa) => pa?.type === 'schedule-therapy'
                )

                const patientName = slot?.userName || slot?.patientName || slot?.patient?.name || 'Unknown Patient'
                const patientNumber = slot?.patientInfo?.patientNumber || slot?.patientNumber
                const patientAge = slot?.patientInfo?.dateOfBirth 
                  ? getAgeFromDobWithTime(slot.patientInfo.dateOfBirth)
                  : slot?.patient?.age
                const patientGender = slot?.patientInfo?.gender || slot?.patient?.gender
                const patientPhone = slot?.patientInfo?.phoneNumber || slot?.patient?.phoneNumber
                const patientEmail = slot?.patientInfo?.email || slot?.patient?.email
                const visitNumber = slot?.patientMeetingSeqNumber
                const isEmergency = slot?.visitEventType === VISIT_EVENT_TYPES.emergency
                const isInProgress = slot?.sessionStatus === BOOKING_SESSION_STATUS?.IN_PROGRESS

                // Get gender label properly
                const genderLabel = patientGender 
                  ? GENDER_LIST_ONBOARDING?.find(g => g.value === patientGender)?.label || patientGender
                  : null

                return (
                  <SlotAccordion
                    key={slot?.id || index}
                    expanded={isExpanded}
                    onChange={(e) => handleSlotExpand(slot?.id || index, e)}
                    $background={slotColors?.background}
                    $borderColor={slotColors?.borderColor}
                    style={{ position: 'relative' }}
                  >
                    <AccordionHeader
                      expandIcon={<ExpandMore sx={{ color: slotColors?.fontColor || 'rgba(67, 56, 202, 0.7)' }} />}
                      $borderColor={slotColors?.borderColor}
                    >
                      <MainInfoRow>
                        <LeftSection>
                          {/* Clinic brand and location info for slots from different clinics */}
                          {showClinicIndicator && (() => {
                            const clinicAssocData = getClinicDataFromAssociations(slot?.clinicId, slot?.clinicBrandId)
                            const brandName = clinicAssocData?.clinicBrandName || slot?.clinicBrandName || 'Unknown Brand'
                            const locationName = clinicAssocData?.clinicLocationName || slot?.clinicName || slot?.clinicLocationName || null
                            return (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 1, flexWrap: 'wrap' }}>
                                <Chip
                                  icon={<Business sx={{ fontSize: 14 }} />}
                                  label={brandName}
                                  size="small"
                                  sx={{
                                    height: 22,
                                    fontSize: 10,
                                    fontWeight: 700,
                                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                                    color: '#4338ca',
                                    border: '1px solid rgba(67, 56, 202, 0.3)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                  }}
                                />
                                {locationName && (
                                  <Chip
                                    icon={<LocationOn sx={{ fontSize: 14 }} />}
                                    label={locationName}
                                    size="small"
                                    sx={{
                                      height: 22,
                                      fontSize: 10,
                                      fontWeight: 600,
                                      background: 'rgba(67, 56, 202, 0.1)',
                                      color: 'rgba(67, 56, 202, 0.8)',
                                      border: '1px solid rgba(67, 56, 202, 0.2)',
                                    }}
                                  />
                                )}
                              </Box>
                            )
                          })()}
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <PatientName sx={{ color: slotColors?.fontColor || 'rgba(0, 0, 0, 0.87)' }}>
                              {patientName}
                            </PatientName>
                            {isEmergency && (
                              <Chip
                                icon={<Block sx={{ fontSize: 14 }} />}
                                label="Emergency"
                                size="small"
                                sx={{
                                  height: 24,
                                  fontSize: 10,
                                  fontWeight: 700,
                                  background: '#dc2626',
                                  color: '#fff',
                                  border: '1px solid #ff2300',
                                }}
                              />
                            )}
                          </Box>
                          <SecondaryInfo>
                            {/* Visit Number - Prominent */}
                            {visitNumber && (
                              <SecondaryChip
                                label={`${visitNumber}${getOrdinalSuffixForSuperScript(visitNumber)} Visit`}
                                size="small"
                                sx={{
                                  background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(167, 139, 250, 0.15) 100%)',
                                  color: '#8b5cf6',
                                  fontWeight: 700,
                                  border: '1px solid rgba(139, 92, 246, 0.3)',
                                  fontSize: 11,
                                }}
                              />
                            )}
                            {/* Video/In Person - Prominent */}
                            <SecondaryChip
                              icon={slotType === 'video' ? <VideoCall sx={{ fontSize: 14 }} /> : <PersonPinCircle sx={{ fontSize: 14 }} />}
                              label={slotType === 'video' ? 'Video Call' : 'In Person'}
                              size="small"
                              sx={{
                                background: slotType === 'video' 
                                  ? 'linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(129, 140, 248, 0.15) 100%)'
                                  : 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                                color: slotType === 'video' ? '#6366f1' : '#4338ca',
                                fontWeight: 600,
                                border: `1px solid ${slotType === 'video' ? 'rgba(99, 102, 241, 0.3)' : 'rgba(67, 56, 202, 0.3)'}`,
                                fontSize: 11,
                              }}
                            />
                            {/* Patient Number */}
                            {patientNumber && (
                              <SecondaryChip
                                label={`PAT #${patientNumber}`}
                                size="small"
                                sx={{
                                  background: 'rgba(16, 185, 129, 0.1)',
                                  color: '#10b981',
                                  fontWeight: 600,
                                  border: '1px solid rgba(16, 185, 129, 0.2)',
                                }}
                              />
                            )}
                            {/* Age/Gender */}
                            {patientAge && genderLabel && (
                              <SecondaryChip
                                label={`${patientAge}${genderLabel.charAt(0)}`}
                                size="small"
                                sx={{
                                  background: 'rgba(236, 72, 153, 0.1)',
                                  color: '#ec4899',
                                  border: '1px solid rgba(236, 72, 153, 0.2)',
                                }}
                              />
                            )}
                            {/* Appointment Number */}
                            {slot?.appointmentNumber && (
                              <SecondaryChip
                                label={`Appt #${slot.appointmentNumber}`}
                                size="small"
                                sx={{
                                  background: 'rgba(245, 158, 11, 0.1)',
                                  color: '#f59e0b',
                                  border: '1px solid rgba(245, 158, 11, 0.2)',
                                }}
                              />
                            )}
                          </SecondaryInfo>
                        </LeftSection>
                        <RightSection>
                          <TimeDisplay sx={{ color: slotColors?.fontColor || 'rgba(67, 56, 202, 0.8)' }}>
                            <AccessTime sx={{ fontSize: 16 }} />
                            {formatTime(slotTime)}
                            {slotEndTime && ` - ${formatTime(slotEndTime)}`}
                          </TimeDisplay>
                          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                            <StatusChip
                              label={getStatusLabel(slot)}
                              size="small"
                              sx={{
                                background: slotColors?.background || 'rgba(67, 56, 202, 0.1)',
                                color: slotColors?.fontColor || 'rgba(67, 56, 202, 0.9)',
                                border: `2px solid ${slotColors?.borderColor || 'rgba(67, 56, 202, 0.2)'}`,
                                fontWeight: 700,
                              }}
                            />
                          </Box>
                        </RightSection>
                      </MainInfoRow>
                    </AccordionHeader>
                    <AccordionContent>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {/* Event Overview - Collapsible Section */}
                        <Accordion defaultExpanded={false} sx={{ boxShadow: 'none', border: '1px solid rgba(67, 56, 202, 0.1)', borderRadius: '8px', mb: 2 }}>
                          <AccordionSummary expandIcon={<ExpandMore sx={{ fontSize: 18, color: 'rgba(67, 56, 202, 0.7)' }} />}>
                            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'rgba(67, 56, 202, 0.8)', display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Info sx={{ fontSize: 18 }} />
                              Event Overview
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails sx={{ pt: 1 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                              {/* Patient Information */}
                              <InfoRow>
                                <InfoLabel>
                                  <Person sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                                  Patient
                                </InfoLabel>
                                <InfoValue>{patientName}</InfoValue>
                              </InfoRow>

                        {patientNumber && (
                          <InfoRow>
                            <InfoLabel>Patient Number</InfoLabel>
                            <InfoValue>{patientNumber}</InfoValue>
                          </InfoRow>
                        )}

                        {(patientAge || genderLabel) && (
                          <InfoRow>
                            <InfoLabel>Age / Gender</InfoLabel>
                            <InfoValue>
                              {patientAge ? `${patientAge} years` : ''}
                              {patientAge && genderLabel ? ' / ' : ''}
                              {genderLabel || ''}
                            </InfoValue>
                          </InfoRow>
                        )}

                        {patientPhone && (
                          <InfoRow>
                            <InfoLabel>
                              <Phone sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                              Phone
                            </InfoLabel>
                            <InfoValue>{patientPhone}</InfoValue>
                          </InfoRow>
                        )}

                        {patientEmail && (
                          <InfoRow>
                            <InfoLabel>
                              <Email sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                              Email
                            </InfoLabel>
                            <InfoValue>{patientEmail}</InfoValue>
                          </InfoRow>
                        )}

                        <Divider sx={{ my: 1 }} />

                        {/* Appointment Information */}
                        {slot?.appointmentNumber && (
                          <InfoRow>
                            <InfoLabel>Appointment #</InfoLabel>
                            <InfoValue>{slot.appointmentNumber}</InfoValue>
                          </InfoRow>
                        )}

                        <InfoRow>
                          <InfoLabel>
                            <AccessTime sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                            Start Time
                          </InfoLabel>
                          <InfoValue>{formatDateTime(slot?.startTime || slotTime)}</InfoValue>
                        </InfoRow>

                        {slotEndTime && (
                          <InfoRow>
                            <InfoLabel>
                              <AccessTime sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                              End Time
                            </InfoLabel>
                            <InfoValue>{formatDateTime(slotEndTime)}</InfoValue>
                          </InfoRow>
                        )}

                        {slot?.eventType && (
                          <InfoRow>
                            <InfoLabel>
                              <CalendarToday sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                              Event Type
                            </InfoLabel>
                            <InfoValue>
                              {displayNamesOfEventTypes?.[slot.eventType] || slot.eventType}
                            </InfoValue>
                          </InfoRow>
                        )}

                        {slot?.chamberRoomName && (
                          <InfoRow>
                            <InfoLabel>
                              <LocalHospital sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                              Chamber Room
                            </InfoLabel>
                            <InfoValue>{slot.chamberRoomName}</InfoValue>
                          </InfoRow>
                        )}

                        <Divider sx={{ my: 1 }} />

                        {/* Status & Payment Information */}
                        <InfoRow>
                          <InfoLabel>
                            <Info sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                            Status
                          </InfoLabel>
                          <InfoValue>{getStatusLabel(slot)}</InfoValue>
                        </InfoRow>

                        {slot?.paymentStatus && (
                          <InfoRow>
                            <InfoLabel>
                              <Payment sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                              Payment Status
                            </InfoLabel>
                            <InfoValue>
                              {slot.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING ? 'Pending' :
                               slot.paymentStatus === BOOKING_PAYMENT_STATUSES.COMPLETED ? 'Completed' :
                               slot.paymentStatus}
                            </InfoValue>
                          </InfoRow>
                        )}

                        {slot?.feePaid && slot?.meetingSrc === SESSION_PLATFORM_OFFLINE && (
                          <InfoRow>
                            <InfoLabel>
                              <Receipt sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
                              Fee Paid
                            </InfoLabel>
                            <InfoValue>
                              {(slot?.currency || 'INR')?.toUpperCase()} {slot.feePaid}
                              {slot?.feePaymentMode && (
                                <span style={{ marginLeft: 8, opacity: 0.7 }}>
                                  ({OFFLINE_PAYMENT_METHODS_LIST.find(m => m.id === slot.feePaymentMode)?.title || slot.feePaymentMode})
                                </span>
                              )}
                            </InfoValue>
                          </InfoRow>
                        )}

                        {visitNumber && (
                          <InfoRow>
                            <InfoLabel>Visit Number</InfoLabel>
                            <InfoValue>
                              {visitNumber}
                              <sup style={{ fontSize: '0.7em', marginLeft: 2 }}>
                                {getOrdinalSuffixForSuperScript(visitNumber)}
                              </sup>
                            </InfoValue>
                          </InfoRow>
                        )}
                            </Box>
                          </AccordionDetails>
                        </Accordion>

                        {/* Actions as Sub-Accordions */}
                        <BookedSlotActionsAccordion
                          bookedSlot={slot}
                          forMentor={forMentor}
                          setClickedBookedSlotData={setClickedBookedSlotData}
                          setEditPatientDialogOpen={setEditPatientDialogOpen}
                          setAddVitalsDialogOpen={setAddVitalsDialogOpen}
                          setEditBookingDialogOpen={setEditBookingDialogOpen}
                          handleNewTherapyRequest={handleNewTherapyRequest}
                          therapyBookingDataForThisEvent={therapyBookingDataForThisEvent}
                          refreshBookedEvents={getAndSetBookedSlotsOfSelectedDate}
                          markBookedSessionAsCompletedFunction={markBookedSessionAsCompletedFunction}
                          handleOpenJoiningDetails={createSlotHandler(slot, 'joiningDetails')}
                          openUploadPrescriptionImagesDialog={createSlotHandler(slot, 'uploadPrescriptionImages')}
                          openBookedEventLogs={createSlotHandler(slot, 'bookedEventLogs')}
                          openEmrImagesDialog={createSlotHandler(slot, 'emrImages')}
                          openSendAssessmentDialog={undefined} // Not available in drawer context
                          openPatientBookingDialog={undefined} // Not available in drawer context
                          openSendTherapyPopover={undefined} // Not available in drawer context
                          handleToggleRecording={createToggleRecordingHandler(slot)}
                          showPrescriptionPdfDownloadButtons={false}
                          openPrescriptionPdfDownloadDialog={undefined} // Not available in drawer context
                          openPaymentLinksDialog={createSlotHandler(slot, 'paymentLinks')}
                          forceShowJoiningDetailsActionButton={forMentor}
                          openRescheduleDialog={createSlotHandler(slot, 'reschedule')}
                          hideRescheduleDialog={hideRescheduleDialog}
                          showViewReportsButtonInActionButtons={true}
                          openReportViewDrawer={openReportViewDrawer}
                          isMainAccordionExpanded={isExpanded}
                          openReceiptDialog={openReceiptDialog}
                          setEventDataForReceiptPrinting={setEventDataForReceiptPrinting}
                        />
                      </Box>
                    </AccordionContent>
                  </SlotAccordion>
                )
              })
            )}
          </DrawerContent>
        </DrawerContainer>
      </Drawer>

      {/* Popup for slot details - reusing existing component */}
      {selectedSlot && (
        <SlotPopupSummary
          clickedBookedSlotData={selectedSlot}
          setClickedBookedSlotAnchor={setSlotPopupAnchor}
          getAndSetBookedSlotsOfSelectedDate={getAndSetBookedSlotsOfSelectedDate}
          markBookedSessionAsCompletedFunction={markBookedSessionAsCompletedFunction}
          platformOptions={platformOptions}
          bookedSlotActionText={bookedSlotActionText}
          pendingActionsOfPerson={pendingActionsOfPerson}
          forMentor={forMentor}
          hideStartButton={hideStartButton}
          hideMarkedCompletedButton={hideMarkedCompletedButton}
          goToEvent={goToEvent}
          setCancelDialogData={setCancelDialogData}
          clickedBookedSlotAnchor={slotPopupAnchor}
          displayNamesOfEventTypes={displayNamesOfEventTypes}
        />
      )}

      {/* Dialogs for actions */}
      {currentSlotForDialogs && (
        <>
          {/* Joining Details Dialog */}
          <Dialog
            open={dialogs.joiningDetails.isOpen}
            maxWidth="lg"
            fullWidth
            onClose={createCloseHandler('joiningDetails')}
          >
            <JoiningDetails
              bookedEventInfo={currentSlotForDialogs}
              closeDialog={createCloseHandler('joiningDetails')}
              refreshBookedSlots={getAndSetBookedSlotsOfSelectedDate}
            />
          </Dialog>

          {/* Booked Event Logs Drawer */}
          <BookedEventLogsDrawer
            open={dialogs.bookedEventLogs.isOpen}
            onClose={createCloseHandler('bookedEventLogs')}
            bookedSlot={currentSlotForDialogs}
          />

          {/* EMR Images Upload Dialog */}
          <EmrImagesUploadDialog
            open={dialogs.emrImages.isOpen}
            bookedEventInfo={currentSlotForDialogs}
            closePopover={createCloseHandler('emrImages')}
            dialogTitle={(() => {
              const eventType = currentSlotForDialogs?.eventType
              if (eventType === EVENT_TYPE_THERAPY_SESSION) return 'Upload Therapy Report Images'
              if (eventType === EVENT_TYPE_SCREENING) return 'Upload Screening Report Images'
              if (eventType === 'assessment' || eventType === 'assessment-report') return 'Upload Assessment Report Images'
              if (eventType === 'investigation' || eventType === 'investigation-report') return 'Upload Investigation Report Images'
              return 'Upload EMR Images'
            })()}
          />

          {/* Reschedule Dialog */}
          <RescheduleSlotDialog
            open={dialogs.reschedule.isOpen}
            onClose={createCloseHandler('reschedule')}
            bookedSlot={currentSlotForDialogs}
            refreshBookedSlots={getAndSetBookedSlotsOfSelectedDate}
          />

          {/* Payment Links Dialog */}
          <Dialog
            open={dialogs.paymentLinks.isOpen}
            maxWidth="lg"
            fullWidth
            onClose={createCloseHandler('paymentLinks')}
          >
            <PaymentLinksViewer
              bookedSlot={currentSlotForDialogs}
              closeDialog={createCloseHandler('paymentLinks')}
              refreshBookedSlots={getAndSetBookedSlotsOfSelectedDate}
            />
          </Dialog>
        </>
      )}
    </>
  )
}
